import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import buscar_azul from "../../images/search_azul.png";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import ProductosCarruselLargo from "./ProductosCarruselLargo";
import { ProductoCarruselCuatro } from "./ProductoCarruselCuatro";
import { ProductoXcategorias } from "./ProductoXcategorias";
import { ProductoXmarcas } from "./ProductoXmarcas";
import { useSearchParams } from "react-router-dom";
import { ModalViewProduct } from "./Modal_view_product";
import { ProductosCarruselLargoSkeleton, CategoryBrandCarouselSkeleton } from "../CaruselSkeleton";
import { CategoriasViewSkeleton, MarcasViewSkeleton } from "../CategoriaMarcaSkeleton";

import LupaIcon from "../../svg/lupaIcon";
import default_img from '../../images/img_default.png';
import '../../css/temporalstyles.css';

import { useProveedorVisita, ModalForAll } from "../../components";
import { toast } from "react-toastify";
import { debounce, throttle } from "lodash";
import { ImagenesGlobal } from "../global/ImagenesGlobal";

export const ProductosVisitas = ({ convertPrice = (() => { }) }) => { //MEJORABLE
	const [mostrarSeccion, setMostrarSeccion] = useState("inicio");
	const productos = useRef([]);

	const [selectedProduct, setSelectedProduct] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loadingProducts, setLoadingProducts] = useState(true);
	const [discountPercentage, setDiscountPercentage] = useState(0);

	const { callInformationCompany, nit, loading, loadImageS } = useProveedorVisita() || {};

	const [searchParams] = useSearchParams();
	const keyCompany = searchParams.get("search");

	const [list15, setList15] = useState([]);
	const [productsCategory, setProductsCategory] = useState([]);
	const [productsBrand, setProductsBrand] = useState([]);
	const [productosFiltrados, setProductosFiltrados] = useState([]);

	const openModal = (product) => {
		setSelectedProduct(product);
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setSelectedProduct(null);
		setIsModalOpen(false);
	};

	const loadDataProducts = async () => {
		try {
			setLoadingProducts(true);

			const data = await callInformationCompany("main");

			const response = await callInformationCompany("products");

			if (response && Object.keys(response).length > 0) {
				var temp_list_15 = []; //Cada valor es un listado de 15 Productos
				var cI = 0; //Contador I
				var temp_list = []; //lista donde tendra los 15 Productos

				const { productosMarcas, productosCategoria } = (response.products ?? []).reduce(
					(acc, producto, indx) => {
						const { brand_name, category_name } = producto;

						if (!acc.productosMarcas[brand_name]) {
							acc.productosMarcas[brand_name] = [];
						}
						acc.productosMarcas[brand_name].push(producto);

						if (!acc.productosCategoria[category_name]) {
							acc.productosCategoria[category_name] = [];
						}
						acc.productosCategoria[category_name].push(producto);

						if (cI == 15 || indx == ((response.products ?? []).length - 1)) {
							temp_list_15.push(temp_list);
							temp_list = [];
							cI = 0;
						} else {
							temp_list[cI] = producto;
							cI++;
						}

						return acc;
					},
					{ productosMarcas: {}, productosCategoria: {} }
				);
				setList15(temp_list_15);
				setProductsCategory(productosCategoria);
				setProductsBrand(productosMarcas);

				productos.current = response.products;

				setDiscountPercentage(
					response.discount_percentage !== null && response.discount_percentage !== undefined
						? response.discount_percentage
						: null
				);
			}
		} catch (error) {
			toast.info("Sin productos registrados...");
		} finally {
			setLoadingProducts(false);
		}

	};
	// useEffect(() => {
	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, []);

	useEffect(() => {
		if (loading == false) {
			window.addEventListener('scroll', handleScroll);

			if (!keyCompany) {
				setLoadingProducts(false);
				return;
			}
			loadDataProducts();
		}

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [loading, nit]);

	const handleToggleSeccion = (seccion) => {
		if (mostrarSeccion === seccion) {
			if (seccion === "inicio") {
				setProductosFiltrados([]);
			}
			return;
		}
		setMostrarSeccion(seccion);

		if (seccion === "categorias" || seccion === "marcas") {
			setProductosFiltrados([]);
		}
	};

	const renderBloquesCompletos2 = () => {
		const count_top15 = list15.length;
		const list_name_categorys = Object.keys(productsCategory);
		const list_name_brand = Object.keys(productsBrand);

		const vueltas_max = Math.max(count_top15, (list_name_categorys.length / 2), (list_name_brand.length / 2));

		const num_ramdon = (max) => {
			// min = Math.ceil(min);
			// max = Math.floor(max);
			// return Math.floor(Math.random() * (max - min + 1)) + min;
			return Math.floor(Math.random() * max);
		}

		const brandsUsed = [];
		const categorysUsed = [];

		const returnCarruselFour = () => {
			const brandOrCategory = num_ramdon(100) % 2 == 0;
			var object_selected = [];
			var backPos = 0;
			var title = "";

			if (brandOrCategory && brandsUsed.length <= list_name_brand.length) {
				backPos = num_ramdon((list_name_brand.length - 1) ?? 0);
				title = list_name_brand[brandsUsed.length] ?? list_name_brand[backPos];
				object_selected = productsBrand[title];

				brandsUsed.push(brandsUsed.length);
			}

			if (!brandOrCategory && categorysUsed.length <= list_name_categorys.length) {
				backPos = num_ramdon((list_name_categorys.length - 1) ?? 0);
				title = list_name_categorys[categorysUsed.length] ?? list_name_categorys[backPos];
				object_selected = productsCategory[title];

				categorysUsed.push(categorysUsed.length);
			}

			if (brandsUsed.length > list_name_brand.length && categorysUsed.length > list_name_categorys.length) {
				backPos = brandOrCategory ? num_ramdon((list_name_brand.length - 1) ?? 0) : num_ramdon((list_name_categorys.length - 1) ?? 0);
				title = brandOrCategory ? list_name_brand[backPos] : list_name_categorys[backPos];
				object_selected = brandOrCategory ? productsBrand[title] : productsCategory[title];
			}

			return {
				title,
				backPos,
				object_selected
			};
		}

		let bodyRender = [];
		for (let iFOR = 0; iFOR < vueltas_max; iFOR++) {
			bodyRender.push(
				<>
					{
						list_name_categorys[iFOR] || list_name_brand[iFOR] || list15[iFOR] ? (
							<div style={{ display: iFOR == 0 ? 'block' : 'none' }} id={`view_product_visit#${iFOR}`} key={`view_product_visit#${iFOR}`}>
								<br></br>
								<div className="main-container-prods">
									<ProductosCarruselLargo
										allProducts={list15[iFOR] ?? list15[num_ramdon(count_top15 - 1)]}
										openModal={openModal}
										showTitle={iFOR == 0 ? "Productos más vendidos" : null}
										discountPercentage={discountPercentage}
										identificador={iFOR}
										loadImageS={loadImageS}
										convertPrice={convertPrice}
									/>
								</div>

								<br></br>

								<div className="main-container-prods">
									{[0, 1, 2].map((catName, i) => {
										return (
											<ProductoCarruselCuatro
												key={iFOR + "_" + i}
												setKey={iFOR + "_" + i}
												title={returnCarruselFour().title ?? "Sin titulo..."}
												listObjects={returnCarruselFour().object_selected ?? []}
												discountPercentage={discountPercentage}
												openModal={openModal}
												closeModal={closeModal}
												type={(iFOR % 2 == 0 && i == 1) || (iFOR % 2 == 1 && i != 1) ? "Uno" : "Cuatro"}
												loadImageS={loadImageS}
												convertPrice={convertPrice}
											/>
										);
									})}
								</div>

							</div>
						)
							: (<></>)
					}
				</>
			);
		}

		return (
			bodyRender
		);
	}

	// Skeleton for the product blocks
	const renderSkeletonBlocks = () => (
		<>
			<ProductosCarruselLargoSkeleton showTitle={" "} />
			<Grid container spacing={2} style={{ marginTop: 20 }}>
				<Grid item xs={12} md={4}>
					<CategoryBrandCarouselSkeleton itemsCount={1} />
				</Grid>
				<Grid item xs={12} md={4}>
					<CategoryBrandCarouselSkeleton itemsCount={1} />
				</Grid>
				<Grid item xs={12} md={4}>
					<CategoryBrandCarouselSkeleton itemsCount={1} />
				</Grid>
			</Grid>
			<ProductosCarruselLargoSkeleton showTitle={null} />
			<Grid container spacing={2} style={{ marginTop: 20 }}>
				<Grid item xs={12} md={4}>
					<CategoryBrandCarouselSkeleton itemsCount={1} />
				</Grid>
				<Grid item xs={12} md={4}>
					<CategoryBrandCarouselSkeleton itemsCount={1} />
				</Grid>
				<Grid item xs={12} md={4}>
					<CategoryBrandCarouselSkeleton itemsCount={1} />
				</Grid>
			</Grid>
		</>
	);

	const styles_active = {
		backgroundColor: 'var(--theme-visit)',
		color: 'var(--theme-main)',
		border: 'none'
	};

	const styles_inactive = {
		backgroundColor: 'var(--theme-main)',
		color: 'var(--theme-visit)',
		border: '1px solid var(--theme-visit)'
	};

	const refCurrentPage = useRef(0);

	const handleScroll = throttle(() => {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		const windowHeight = window.innerHeight;
		const scrollHeight = (document.documentElement.scrollHeight || document.body.scrollHeight) - 150;

		if (scrollTop + windowHeight >= scrollHeight) {
			const activate_view = document.getElementById('view_product_visit#' + refCurrentPage.current);
			if (activate_view) {
				activate_view.style.display = 'block';
				refCurrentPage.current = refCurrentPage.current + 1;
			}
		}
	}, 500); // Ejecuta cada 200ms, ajusta este valor según sea necesario


	const debouncedSearch = useCallback(
		debounce((item) => {
			const textSearch = String(item.target.value).toLowerCase();
			if (textSearch.trim() == '') return setProductosFiltrados([]);

			const result = productos.current.filter((producto) => {
				const nombre = producto.product_name?.toLowerCase() || "";
				const marca = producto.brand_name?.toLowerCase() || "";
				const categoria = producto.category_name?.toLowerCase() || "";
				const codigo = producto.code?.toLowerCase?.() || "";
				const precio = String(producto.sale_price || "").toLowerCase();

				return (
					nombre.includes(textSearch) ||
					marca.includes(textSearch) ||
					categoria.includes(textSearch) ||
					codigo.includes(textSearch) ||
					precio.includes(textSearch)
				);
			});

			setProductosFiltrados(result);
		}, 700),
		[nit]
	);

	return (
		<div className="container-products-visitas" style={{ gap: '0px' }} key={"productos_" + nit}>
			<div
				className="header-visitas"
				style={{
					display: "flex",
					justifyContent: "space-between",
				}}>
				<div className="change-cat-bra" >
					<button
						className="btn-default-visit"
						style={mostrarSeccion == "inicio" ? styles_active : styles_inactive}
						onClick={() => handleToggleSeccion("inicio")}
					>
						Inicio
					</button>

					<button
						className="btn-default-visit"
						style={mostrarSeccion == "categorias" ? styles_active : styles_inactive}
						onClick={() => handleToggleSeccion("categorias")}
					>
						Categorías
					</button>

					<button
						className="btn-default-visit"
						style={mostrarSeccion == "marcas" ? styles_active : styles_inactive}
						onClick={() => handleToggleSeccion("marcas")}
					>
						Marcas
					</button>
				</div>

				<div className="seccion-nav search search-funcionality" style={{ border: `1px solid var(--theme-visit)` }}>
					<Box sx={{ marginLeft: "5px", marginRight: "5px" }}>
						<LupaIcon color={'var(--theme-visit)'} size={'var(--fon-icons)'} />
					</Box>
					<input
						type="search"
						id="buscador"
						placeholder="Buscar producto..."
						onChange={debouncedSearch}
						style={{ border: `1px solid var(--theme-visit)`, borderLeft: "transparent" }}
					/>
				</div>

				<div style={{ display: "flex", alignItems: "center", gap: "10px", paddingRight: "10px" }}>
					{discountPercentage != null &&
						(discountPercentage > 0 ? (
							<Typography
								variant="body2"
								sx={{
									border: `1px solid var(--theme-visit)`,
									color: 'var(--theme-visit)',
									padding: "8px",
									borderRadius: "10px",
									fontWeight: "700",
									letterSpacing: "0.5px",
								}}>
								{discountPercentage}% Descuento
							</Typography>
						) : discountPercentage === 0 ? (
							<Typography
								variant="body2"
								sx={{
									border: `1px solid var(--theme-visit)`,
									color: 'var(--theme-visit)',
									padding: "8px",
									borderRadius: "10px",
									fontWeight: "700",
									letterSpacing: "0.5px",
								}}>
								Precio Mayorista
							</Typography>
						) : null)}
				</div>
			</div>

			<div className="contenido-products-visitas" style={{ width: '100%' }}>
				{loadingProducts ? (
					renderSkeletonBlocks()
				) : Array.from(productosFiltrados).length > 0 ? (
					<div
						style={{
							backgroundColor: "#fff",
							padding: "20px",
						}}
						className="all-products"
					>
						{productosFiltrados.map((producto, index) => {
							return (
								<Card
									key={index}
									onClick={() => openModal(producto)}
									style={{
										cursor: "pointer",
										boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
										transition: "transform 0.2s ease, box-shadow 0.2s ease",
										paddingBottom: "0px",
									}}
									className="shadow-lvl8"
								>
									<ImagenesGlobal url={producto?.img_list[0] ?? null} style={{ objectFit: 'cover', width: '100%' }} key={producto?.code + producto?.reference} loadImageS={loadImageS} />
									<CardContent
										sx={{
											"p": 0,
											"&:last-child": { paddingBottom: 0 },
											"boxShadow": "none",
										}}
										style={{
											padding: "8px",
											display: "flex",
											alignItems: "flex-start",
											justifyContent: "space-between",
											gap: "8px",
										}}>
										<Typography
											variant="body2"
											style={{
												fontWeight: "bold",
												fontSize: "0.8rem",
												textAlign: "left",
												display: "-webkit-box",
												WebkitLineClamp: 2,
												WebkitBoxOrient: "vertical",
												overflow: "hidden",
												textOverflow: "ellipsis",
												lineHeight: "1.2em",
												maxHeight: "2.4em",
												flex: 1,
											}}
											title={producto.product_name}>
											{producto.product_name}
										</Typography>

										{discountPercentage > 0 ? (
											<div
												style={{
													textAlign: "right",
													display: "flex",
													flexDirection: "column",
												}}>
												<Typography
													variant="caption"
													sx={{
														fontSize: "0.7rem",
														textDecoration: "line-through",
														color: "#999",
													}}>
													{convertPrice(producto.sale_price, producto?.currency)}
												</Typography>
												<Typography
													variant="caption"
													color="green"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
													}}>
													{convertPrice(parseFloat(producto.sale_price) * (1 - discountPercentage / 100), producto?.currency)}
												</Typography>
											</div>
										) : (
											<Typography
												variant="caption"
												color="green"
												sx={{
													fontSize: "0.75rem",
													fontWeight: 600,
													whiteSpace: "nowrap",
													alignSelf: "flex-start",
												}}>
												{convertPrice(producto.sale_price, producto?.currency)}
											</Typography>
										)}
									</CardContent>
								</Card>
							);
						})}
					</div>
				) : mostrarSeccion === "categorias" ? (
					<ProductoXcategorias
						allCategory={productsCategory}
						discountPercentage={discountPercentage}
						default_img={default_img}
						openModal={openModal}
						loadImageS={loadImageS}
						convertPrice={convertPrice}
					/>
				) : mostrarSeccion === "marcas" ? (
					<ProductoXmarcas
						allCategory={productsBrand}
						discountPercentage={discountPercentage}
						default_img={default_img}
						openModal={openModal}
						loadImageS={loadImageS}
						convertPrice={convertPrice}
					/>
				) : mostrarSeccion === "inicio" ? (renderBloquesCompletos2()
				) : (<Typography variant="subtitle1">No se encontraron productos.</Typography>)}
			</div>

			<ModalForAll stateModal={isModalOpen} setStateModal={closeModal} className='modal-detail-products'>
				<ModalViewProduct
					isOpen={isModalOpen}
					product={selectedProduct}
					allProducts={productos.current} // 🔥 Agregado
					onSelectProduct={(prod) => setSelectedProduct(prod)}
					discountPercentage={discountPercentage}
					loadImageS={loadImageS}
					convertPrice={convertPrice}
				/>
			</ModalForAll>
		</div>
	);
};
